<nz-footer class="text-center login-footer">
	&copy; {{today | date:'yyyy'}} Guglielmo - <i>v{{version}}</i>
</nz-footer>